import ApexChatInit from './apexchat';
import GlobalVariables from './core/GlobalVariables';
import isMobile from './isMobile';
import { isTabletOrIpad } from './isTabletOrIpad';

class companyProfileHandler {
    setbaseCDNUrl() {
        const me = this;
        me.unCachedUrl = env.UncachedCDNBaseUrl;
        me.baseCDNUrl = env.ExternalCDNBaseUrl;
        const script = document.currentScript;
        if (
            (script.src &&
                (script.src.indexOf('index.bundle') > -1 || script.src.indexOf('invitation.ashx') > -1)
            )
        ) {
            if (script.src.indexOf('apex') > -1) {
                me.baseCDNUrl = env.InternalCDNBaseUrl;
            }
        }
        GlobalVariables.CdnBaseUrl = me.baseCDNUrl + '/';
    }
    async loadOptions(ismobile, istablet, async = true) {
        if (env.IsCDN === 'true') { // Every company should be using cdn.
            console.log('Invitation with cdn');
            this.setbaseCDNUrl();
        } else {
            GlobalVariables.CdnBaseUrl = env.API_URL + '/';
        }

        var clientScript = document.currentScript;
        // myScript now contains our script object
        var queryString = clientScript.src.replace(/^[^\?]+\??/, '');
        const urlParams = new URLSearchParams(queryString);
        const companyKey = urlParams.get('company');
        const botId = urlParams.get('cbid');
        let response;
        if (botId) {
            response = await fetch(`${GlobalVariables.CdnBaseUrl}api/invitations/options?cbid=${botId}&mobile=${ismobile}&tablet=${istablet}`);
        } else {
            response = await fetch(
                `${GlobalVariables.CdnBaseUrl}api/invitations/options?company=${companyKey}&mobile=${ismobile}&tablet=${istablet}`
            );
        }
        if (response.ok) {
            const json = await response.json();
            if (json && json.statusCode === 400) {
                console.warn(json.message);
                return;
            }
            ApexChat.slimInit = json;
            GlobalVariables.ApexChatBetaUrl = json.ApexChatBetaUrl;
            GlobalVariables.ApexChatBaseUrl = json.ApexChatBaseUrl;
            window.ApexChatBaseUrl = GlobalVariables.ApexChatBaseUrl;
            GlobalVariables.ApexChatDefaultLogLevel = json.ApexChatDefaultLogLevel;
            GlobalVariables.LiveChatServiceUrl = env.LiveChatServiceUrl;
            GlobalVariables.CompanyContextRequest = json.companyContextRequest;
            GlobalVariables.CompanyLevelSettings = json.companyLevelSettings;
            GlobalVariables.CompanyLevelBlockedPages = json.CompanyLevelBlockedPages;
            ApexChat.Invitation = { config: json };


            ApexChatInit();
        } else {
            const error = await response.json();
            //alert(`HTTP-Error: ${response.status}`);
            console.error(error?.detail || error);
        }
    }
}
const profile = new companyProfileHandler();

profile.loadOptions(isMobile(), isTabletOrIpad(), true);
